import React from 'react';
import { FaRegBuilding, FaCogs, FaCloud, FaRegGem } from 'react-icons/fa';  // Importing React Icons

const Services = () => {
  return (
    <div className="bg-gray-700 p-4 min-h-screen w-11/12 mx-auto mt-10">
      <div aria-hidden="true" className="absolute inset-0 h-max w-full m-auto grid grid-cols-2 -space-x-52 opacity-20">
        <div className="blur-[106px] h-56 bg-gradient-to-br to-purple-400 from-blue-700"></div>
        <div className="blur-[106px] h-32 bg-gradient-to-r from-cyan-400 to-indigo-600"></div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 xl:px-6">
      <div className="mx-auto text-center md:w-2/3 lg:w-1/2 mt-12 text-gray-100">
  <h2 className="my-8 text-2xl font-bold text-white md:text-4xl">About Our Service</h2>
  <p className="text-gray-300">
    We help homeowners and home occupiers like you hold pavement parkers accountable.
  </p>
</div>

        <div className="mt-16 grid divide-x divide-y divide-gray-700 overflow-hidden rounded-3xl border text-gray-600 border-gray-700 sm:grid-cols-2 lg:grid-cols-4 lg:divide-y-0 xl:grid-cols-4">
          <div className="group relative bg-gray-800 transition hover:z-[1] hover:shadow-2xl hover:shadow-gray-600/10">
            <div className="relative space-y-8 py-12 p-8">
              <FaRegBuilding className="w-12 h-12 text-secondary" />
              <div className="space-y-2">
                <h5 className="text-xl font-semibold text-white transition group-hover:text-secondary">Legal Filing</h5>
                <p className="text-gray-300">We handle all the legal details to hold pavement parkers accountable.</p>
              </div>
            </div>
          </div>
          <div className="group relative bg-gray-800 transition hover:z-[1] hover:shadow-2xl hover:shadow-gray-600/10">
            <div className="relative space-y-8 py-12 p-8">
              <FaCogs className="w-12 h-12 text-secondary" />
              <div className="space-y-2">
                <h5 className="text-xl font-semibold text-white transition group-hover:text-secondary">Streamlined Process</h5>
                <p className="text-gray-300">We make it easy for you by taking care of everything, from start to finish.</p>
              </div>
            </div>
          </div>
          <div className="group relative bg-gray-800 transition hover:z-[1] hover:shadow-2xl hover:shadow-gray-600/10">
            <div className="relative space-y-8 py-12 p-8">
              <FaCloud className="w-12 h-12 text-secondary" />
              <div className="space-y-2">
                <h5 className="text-xl font-semibold text-white transition group-hover:text-secondary">Follow-ups</h5>
                <p className="text-gray-300">We manage follow-ups and ensure everything is on track for you.</p>
              </div>
            </div>
          </div>
          <div className="group relative bg-gray-800 transition hover:z-[1] hover:shadow-2xl hover:shadow-gray-600/10">
            <div className="relative space-y-8 py-12 p-8">
              <FaRegGem className="w-12 h-12 text-secondary" />
              <div className="space-y-2">
                <h5 className="text-xl font-semibold text-white transition group-hover:text-secondary">Reclaim Your Space</h5>
                <p className="text-gray-300">With our expertise, we help you reclaim your space with minimal hassle.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
